module.exports = __webpack_public_path__ + "assets/059637e015bc6a0d290b2b51e4b29ad8.jpg";